import React from 'react'
import { Typography } from 'antd'
import { Section } from '../../sections'
import SectionIcon from './SectionIcon'
const { Title, Paragraph } = Typography

interface SectionHeaderProps {
    section: Section
    title: string
    summary: string
}

// One line of title and up to two lines of summary, cut with an ellipsis (full text on hover)
const SectionHeader: React.FC<SectionHeaderProps> = ({ section, title, summary }) => (
    <div className="section-header">
        <span className="section-header-icon">
            <SectionIcon section={section} size={30} />
        </span>
        <div className="section-header-text">
            <Title level={2} className="section-header-title" title={title}>
                {title}
            </Title>
            <Paragraph type="secondary" className="section-header-summary" title={summary}>
                {summary}
            </Paragraph>
        </div>
    </div>
)

export default SectionHeader
